import React, { useEffect, useRef } from 'react';

const CapacityVsCyclePlot = () => {
  const plotRef = useRef(null);

  useEffect(() => {
    // Load Plotly script if not already loaded
    if (!window.Plotly) {
      const script = document.createElement('script');
      script.src = 'https://cdn.plot.ly/plotly-latest.min.js';
      script.onload = () => {
        renderPlot();
      };
      document.head.appendChild(script);
    } else {
      renderPlot();
    }

    function renderPlot() {
      const plot_json = {
        "data": [
          {
            "mode": "lines",
            "name": "Capacity vs. Cycle",
            "x": [0.0, 2.842809364548495, 5.68561872909699, 17.05685618729097, 19.899665551839465, 36.95652173913042, 51.17056856187289, 54.01337792642138, 56.85618729096988, 144.9832775919733, 147.82608695652178, 150.66889632107026, 153.51170568561875, 156.35451505016724, 159.19732441471572, 164.8829431438127, 167.72575250836118, 170.56856187290967, 204.6822742474915, 213.21070234113697, 218.89632107023397, 241.63879598662183, 244.48160535117032, 253.01003344481575, 255.85284280936423, 258.6956521739128, 261.53846153846126, 272.9096989966552, 275.7525083612037, 295.6521739130431, 298.4949832775916, 309.86622073578553, 312.709030100334, 315.5518394648825, 318.394648829431, 326.92307692307645, 335.4515050167219, 338.2943143812704, 341.1371237458189, 343.97993311036737, 346.82274247491586, 355.3511705685613, 358.1939799331098, 386.62207357859467, 389.4648829431432, 400.8361204013371, 403.6789297658856, 412.20735785953104, 415.05016722407953, 417.892976588628, 420.7357859531765, 423.578595317725, 426.4214046822735, 437.7926421404674, 440.6354515050159, 469.0635451505008, 471.90635451504926, 474.74916387959775, 477.59197324414623, 488.9632107023402, 491.8060200668887, 494.6488294314372, 497.4916387959856, 500.3344481605341, 523.0769230769222, 525.9197324414707, 528.7625418060193, 540.1337792642134, 577.0903010033445, 579.933110367893, 585.6187290969901, 588.4615384615387, 591.3043478260872, 594.1471571906358, 596.9899665551843, 622.5752508361212, 625.4180602006697, 628.2608695652183, 631.1036789297668, 633.9464882943154, 636.7892976588639, 639.6321070234125, 642.474916387961, 645.3177257525095, 673.745819397995, 676.5886287625435, 696.4882943143833, 699.3311036789319, 702.1739130434804, 705.016722408029, 707.8595317725775, 710.702341137126, 713.5451505016746, 716.3879598662231, 719.2307692307717, 724.9163879598688, 727.7591973244173, 730.6020066889658, 733.4448160535144, 736.2876254180629, 747.6588628762571, 750.5016722408056, 753.3444816053542, 756.1872909699027, 759.0301003344513, 761.8729096989998, 767.5585284280969, 770.4013377926454, 773.244147157194, 776.0869565217425, 784.6153846153882, 787.4581939799367, 790.3010033444853, 793.1438127090338, 795.9866220735823, 798.8294314381309, 801.6722408026794, 804.515050167228, 807.3578595317765, 810.200668896325, 813.0434782608736, 815.8862876254221, 818.7290969899707, 821.5719063545192, 824.4147157190678, 830.1003344481649, 832.9431438127134, 835.785953177262, 838.6287625418105, 841.471571906359, 844.3143812709076, 847.1571906354561, 850.0000000000047],
            "y": [1.075, 1.075, 1.075, 1.075, 1.075, 1.072944550669216, 1.070889101338432, 1.070889101338432, 1.070889101338432, 1.0606118546845125, 1.0585564053537284, 1.0585564053537284, 1.0585564053537284, 1.0585564053537284, 1.0585564053537284, 1.0565009560229446, 1.0565009560229446, 1.0565009560229446, 1.0503346080305929, 1.0503346080305929, 1.0503346080305929, 1.046223709369025, 1.044168260038241, 1.042112810707457, 1.042112810707457, 1.042112810707457, 1.042112810707457, 1.040057361376673, 1.040057361376673, 1.033891013384321, 1.033891013384321, 1.0318355640535373, 1.0318355640535373, 1.0318355640535373, 1.0318355640535373, 1.0297801147227534, 1.0277246653919694, 1.0277246653919694, 1.0256692160611856, 1.0256692160611856, 1.0256692160611856, 1.0236137667304015, 1.0236137667304015, 1.0153919694072655, 1.0153919694072655, 1.009225621414914, 1.009225621414914, 1.00717017208413, 1.005114722753346, 1.003059273422562, 1.003059273422562, 1.003059273422562, 1.003059273422562, 1.0010038240917782, 1.0010038240917782, 0.9619502868068834, 0.9640057361376674, 0.9640057361376674, 0.9619502868068834, 0.9825047801147228, 0.9825047801147228, 0.9825047801147228, 0.9804493307839388, 0.9804493307839388, 0.9701720841300192, 0.9701720841300192, 0.9701720841300192, 0.9619502868068834, 0.941395793499044, 0.93934034416826, 0.937284894837476, 0.9352294455066922, 0.9331739961759082, 0.9311185468451244, 0.9311185468451244, 0.9105640535372848, 0.9105640535372848, 0.9085086042065008, 0.906453154875717, 0.9043977055449332, 0.8797323135755258, 0.875621414913958, 0.873565965583174, 0.8632887189292543, 0.8673996175908222, 0.8653441682600382, 0.840678776290631, 0.840678776290631, 0.8324569789674953, 0.8304015296367113, 0.8304015296367113, 0.8262906309751434, 0.8201242829827916, 0.8180688336520077, 0.8119024856596558, 0.8016252390057361, 0.7995697896749522, 0.7934034416826004, 0.7913479923518164, 0.7892925430210325, 0.7625717017208413, 0.7564053537284895, 0.7522944550669216, 0.7481835564053537, 0.737906309751434, 0.737906309751434, 0.7152963671128107, 0.7111854684512429, 0.7029636711281071, 0.6988527724665392, 0.6700764818355641, 0.6639101338432123, 0.6556883365200765, 0.6495219885277247, 0.6351338432122371, 0.6269120458891013, 0.6186902485659656, 0.6145793499043977, 0.5940248565965583, 0.5878585086042065, 0.5755258126195029, 0.5673040152963671, 0.5570267686424474, 0.5467495219885278, 0.540583173996176, 0.5118068833652007, 0.5076959847036329, 0.5056405353728489, 0.4789196940726578, 0.4789196940726578, 0.4748087954110899, 0.4460325047801147, 0.4460325047801147],
            "type": "scatter"
          },
          {
            "marker": {"color": "red", "size": 10},
            "mode": "markers",
            "name": "Initial cycle",
            "x": [0.0],
            "y": [1.075],
            "type": "scatter"
          },
          {
            "marker": {"color": "red", "size": 10},
            "mode": "markers",
            "name": "Knee onset",
            "x": [702.1739130434804],
            "y": [0.8324569789674953],
            "type": "scatter"
          },
          {
            "marker": {"color": "red", "size": 10},
            "mode": "markers",
            "name": "Knee point",
            "x": [784.6153846153882],
            "y": [0.6700764818355641],
            "type": "scatter"
          },
          {
            "marker": {"color": "red", "size": 10},
            "mode": "markers",
            "name": "EOL",
            "x": [850.0000000000047],
            "y": [0.4460325047801147],
            "type": "scatter"
          },
          {
            "marker": {"color": "purple", "size": 15, "symbol": "star"},
            "mode": "markers",
            "name": "SoH (This Cell): 275",
            "x": [275],
            "y": [1.040057361376673],
            "type": "scatter"
          }
        ],
        "layout": {
          "annotations": [
            {"arrowhead": 2, "ax": 0, "ay": -40, "showarrow": true, "text": "Initial cycle", "x": 0.0, "y": 1.075},
            {"arrowhead": 2, "ax": 0, "ay": -40, "showarrow": true, "text": "Knee onset", "x": 702.1739130434804, "y": 0.8324569789674953},
            {"arrowhead": 2, "ax": 0, "ay": -40, "showarrow": true, "text": "Knee point", "x": 784.6153846153882, "y": 0.6700764818355641},
            {"arrowhead": 2, "ax": 0, "ay": -40, "showarrow": true, "text": "EOL", "x": 850.0000000000047, "y": 0.4460325047801147},
            {"arrowhead": 2, "ax": 0, "ay": 40, "showarrow": true, "text": "SoH (This Cell): 275", "x": 275, "y": 1.040057361376673}
          ],
          "modebar": {"orientation": "v"},
          "showlegend": true,
          "title": {"text": "Capacity vs. Cycle Plot"},
          "xaxis": {
            "title": {"text": "Cycle"},
            "gridcolor": "#283442",
            "linecolor": "#506784",
            "tickcolor": "#506784",
            "tickfont": {"color": "#f2f5fa"},
            "zerolinecolor": "#283442",
            "zerolinewidth": 2,
            "showgrid": true
          },
          "yaxis": {
            "title": {"text": "Capacity (mAh)"},
            "gridcolor": "#283442",
            "linecolor": "#506784",
            "tickcolor": "#506784",
            "tickfont": {"color": "#f2f5fa"},
            "zerolinecolor": "#283442",
            "zerolinewidth": 2,
            "showgrid": true
          },
          "paper_bgcolor": "black",
          "plot_bgcolor": "black",
          "font": {"color": "#f2f5fa"}
        }
      };

      // Scale y data to mAh
      let maxY = Math.max(...plot_json.data.flatMap(trace => trace.y || []));
      let scale = 5000 / maxY;
      plot_json.data.forEach(function(trace) {
        if (trace.y) {
          trace.y = trace.y.map(function(val) { return val * scale; });
        }
      });
      if (plot_json.layout && Array.isArray(plot_json.layout.annotations)) {
        plot_json.layout.annotations.forEach(function(annotation) {
          if (typeof annotation.y === 'number') {
            annotation.y = annotation.y * scale;
          }
        });
      }
      plot_json.layout.yaxis = plot_json.layout.yaxis || {};
      plot_json.layout.yaxis.range = [0, 5000];
      plot_json.layout.yaxis.autorange = true;
      plot_json.layout.yaxis.title = { text: 'Capacity (mAh)' };

      if (plotRef.current) {
        window.Plotly.newPlot(plotRef.current, plot_json.data, plot_json.layout, {responsive: true});
      }
    }

    return () => {
      // Cleanup if needed
    };
  }, []);

  return (
    <div 
      ref={plotRef} 
      style={{ 
        width: '100%', 
        height: '500px',
        backgroundColor: 'black'
      }} 
    />
  );
};

export default CapacityVsCyclePlot;
